module.exports = __webpack_public_path__ + "static/media/room8.bdcc6476.png";